// routes
import { paths } from '@/routes/paths';
import { useLocales } from '@/hooks';
import { useAuthContext } from '@/auth/hooks';
import { useMemo } from 'react';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const { user } = useAuthContext();
  const data = useMemo(
    () => [
      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('Settings'),
        items: [
          {
            title: t('General'),
            path: paths.setting.general.root,
            icon: 'settings',
            children: [
              { title: t('Countries'), path: paths.setting.general.countries.root },
              { title: t('Currencies'), path: paths.setting.general.currencies.root },
            ],
          },
          {
            title: t('Accounts'),
            path: paths.setting.accounts.root,
            icon: 'accountCircle',
            children: [
              { title: t('Organizations'), path: paths.setting.accounts.industries.root },
              { title: t('Opportunities'), path: paths.setting.accounts.opportunities.root },
              {
                title: t('Presales Stages'),
                path: paths.setting.accounts.presalesTicketStages.root,
              },
              {
                title: t('Presales'),
                path: paths.setting.accounts.presales.root,
              },
            ],
            // children: [
            //   { title: t('Industries'), path: paths.management.accounts.organizations.root },
            //   { title: t('Segments'), path: paths.management.accounts.contacts.root },
            //   { title: t('Life Cycle Stages'), path: paths.management.accounts.subcriptions.root },
            //   { title: t('Churn Reasons'), path: paths.management.accounts.subcriptions.root },
            // ],
          },
          {
            title: t('Approval Flow'),
            path: paths.setting.approvalFlow.root,
            icon: 'localstore',
            children: [
              { title: t('Purchase Orders'), path: paths.setting.approvalFlow.purchaseOrders.root },
              { title: t('Billing Orders'), path: paths.setting.approvalFlow.billingOrders.root },
              { title: t('New User'), path: paths.setting.approvalFlow.newuser.root },
            ],
          },
          {
            title: t('Portfolio'),
            path: paths.setting.portfolio.root,
            icon: 'inventory',
            children: [
              { title: t('Product and Plans'), path: paths.setting.portfolio.productTypes.root },
            ],
          },
          // TODO: hidden - Catalog Sections (Section Management, Partner Sections, Product Sections)
          // {
          //   title: t('Catalog Sections'),
          //   path: paths.setting.catalogSections.root,
          //   icon: 'category',
          //   children: [
          //     { title: t('Section Management'), path: paths.setting.catalogSections.list },
          //     {
          //       title: t('Partner Sections'),
          //       path: paths.setting.catalogSections.partnerSections.root,
          //     },
          //     {
          //       title: t('Product Sections'),
          //       path: paths.setting.catalogSections.productSections.root,
          //     },
          //   ],
          // },
          {
            title: t('Finances'),
            path: paths.setting.finances.root,
            icon: 'attachMoney',
            children: [{ title: t('Payments'), path: paths.setting.finances.payments.root }],
          },
          {
            title: t('Access'),
            path: paths.setting.access.root,
            icon: 'changeCircle',
            children: [
              { title: t('Logs'), path: paths.setting.access.logs.root },
              { title: t('Feature Flags'), path: paths.setting.access.featureFlags.root },
            ],
          },
          {
            title: t('Integrations'),
            path: paths.setting.integrations.root,
            icon: 'mdi:connection',
            children: [
              { title: t('Odoo Sync'), path: paths.setting.integrations.odooSync.root },
              { title: t('LLM Providers'), path: paths.setting.integrations.llms.root },
            ],
          },
          ...(user?.isAdmin
            ? [
                {
                  title: t('Directory'),
                  path: paths.setting.directory.root,
                  icon: 'group',
                  children: [
                    { title: t('Orioners'), path: paths.setting.directory.user.root },
                    { title: t('Users'), path: paths.setting.directory.usermkt.root },
                    { title: t('Teams'), path: paths.setting.directory.teams.root },
                    { title: t('Roles'), path: paths.setting.directory.roles.root },
                    { title: t('Transactions'), path: paths.setting.directory.banks.root },
                  ],
                },
              ]
            : []),
        ],
      },
    ],
    [t, user]
  );

  return data;
}
